import type { StatusPillTone } from "./StatusPill";

/**
 * Shared 'pendiente' | 'validado' catalogue -> StatusPill tone mapping
 * (MEMORY.md: a developer's `authorization_to_sell_status` and a project's
 * `compliance_pack_status` are the exact same two-state catalogue, so one
 * mapping is reused by both resources instead of duplicated).
 */
export interface CatalogueStatusPillMapping {
  tone: StatusPillTone;
  /**
   * The catalogue value to translate, or `null` for an unexpected value.
   * Kept translate-free (no i18n dependency here) so this stays a pure,
   * trivially unit-testable function; the caller resolves `labelKey` to a
   * resource-specific message key and falls back to the raw value when
   * `labelKey` is `null`, so a legacy/unknown status never crashes the
   * screen.
   */
  labelKey: "pendiente" | "validado" | null;
}

export function toCatalogueStatusPillMapping(
  status: unknown,
): CatalogueStatusPillMapping {
  if (status === "validado") {
    return { tone: "ok", labelKey: "validado" };
  }
  if (status === "pendiente") {
    return { tone: "not-ok", labelKey: "pendiente" };
  }
  return { tone: "not-ok", labelKey: null };
}
